export const removeAccents = (str: string) => {
    return str
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[đĐ]/g, "d")
        .replace(/[âÂ]/g, "a")
        .replace(/[êÊ]/g, "e")
        .replace(/[.,:"'<>?`!@#$%^&*();/\\]/g, "")
        .replace(/\s+/g, "-")
        .toLowerCase()
}

/**
 * Converts any string into a valid URL slug.
 * Allowed output chars: a-z, 0-9, -
 * Example: "BỐC THĂM TRÚNG THƯỞNG CÙNG LAY'S!" → "boc-tham-trung-thuong-cung-lays"
 */
export const generateSlug = (str: string): string =>
  str
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[đĐ]/g, "d")
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/[\s-]+/g, "-")
    .replace(/^-+|-+$/g, "")
